import type { CSSProperties } from 'react'
import { mascot, type MascotPose } from '@/content/site'
import './mascot.css'

type Props = {
  pose: MascotPose
  /** CSS height in px. Width follows the sprite's aspect, so nothing shifts while it loads. */
  height: number
  /** The slow idle bob (off under reduced motion). */
  bob?: boolean
  className?: string
  /** Above the fold: load straight away. */
  eager?: boolean
}

/** A decorative mascot sprite at a fixed CSS size (always smaller than the file, never upscaled). */
export function Mascot({ pose, height, bob = false, className, eager = false }: Props) {
  const m = mascot[pose]
  const h = Math.min(height, m.height)
  const w = Math.round((m.width * h) / m.height)
  return (
    <span
      className={`mascot${className ? ` ${className}` : ''}`}
      data-pose={pose}
      data-bob={bob || undefined}
      style={{ '--mascot-h': `${h}px` } as CSSProperties}
      aria-hidden
    >
      <img src={m.src} alt="" width={w} height={h} loading={eager ? 'eager' : 'lazy'} decoding="async" draggable={false} />
    </span>
  )
}
